// src/components/Pager.js
import React from 'react';

function buildPageList(page, total) {
  const pages = new Set([1, total, page - 1, page, page + 1, 2, total - 1]);
  const valid = [...pages].filter(p => p >= 1 && p <= total).sort((a, b) => a - b);
  const out = [];
  for (let i = 0; i < valid.length; i++) {
    out.push(valid[i]);
    if (i < valid.length - 1 && valid[i + 1] !== valid[i] + 1) out.push('…');
  }
  return out;
}

export default function Pager({ page, total, onChange }) {
  if (total <= 1) return null;
  const list = buildPageList(page, total);
  return (
    <nav className="pager">
      <button
        className="pagerArrow"
        disabled={page === 1}
        onClick={() => onChange(page - 1)}
        aria-label="Prev"
      >
        ‹
      </button>
      {list.map((p, i) =>
        p === '…' ? (
          <span key={`e${i}`} className="pagerEllipsis">• • •</span>
        ) : (
          <button
            key={p}
            className={`pagerBtn ${p === page ? 'active' : ''}`}
            onClick={() => onChange(p)}
          >
            {p}
          </button>
        )
      )}
      <button
        className="pagerArrow"
        disabled={page === total}
        onClick={() => onChange(page + 1)}
        aria-label="Next"
      >
        ›
      </button>
    </nav>
  );
}
